import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearUserDetailsState } from '../../../redux/slices/authSlice';
import { setAlertText, setSeverity, setToast } from '../../../redux/slices/commonComponentSlice';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is already logged out
    const accessToken = Cookies.get('access_token');
    if (!accessToken) {
      // If not logged in, redirect to login page
      navigate('/login');
    }
  }, [navigate, dispatch]);
  const logout = async () => {
    try {
      const accessToken = Cookies.get('access_token');
      
      if (accessToken) {
        // Call logout API
        await fetch('https://app.liquid.diamonds/signout.json', {
          method: 'DELETE',
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'ngrok-skip-browser-warning': true,
          },
        });
      }
    } catch (error) {
      console.error('Logout API error:', error);
      // Continue with local logout even if API fails
    } finally {
      // Clear local storage and cookies
      Cookies.remove('access_token');
      
      // Clear Redux state
      dispatch(clearUserDetailsState());
      
      // Show logout toast
      // dispatch(setToast({
      //   openToast: true,
      //   severity: 'info',
      //   alertText: 'You have been logged out successfully.'
      // }));
      dispatch(setToast(true));
      dispatch(setAlertText('You have been logged out successfully.'));
      dispatch(setSeverity('info'));

      
      // Navigate to login
    }
  };

  return logout;
};